'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(r, o) {
    if (null == r) return {};
    var t, e, n = _object_without_properties_loose(r, o);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(r);
        for(e = 0; e < p.length; e++)t = p[e], !(o.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(r, t) && (n[t] = r[t]);
    }
    return n;
}
function _object_without_properties_loose(r, o) {
    if (null == r) return {};
    var t, e, n = {}, p = Object.keys(r);
    for(e = 0; e < p.length; e++)t = p[e], o.indexOf(t) >= 0 || (n[t] = r[t]);
    return n;
}
const DropdownOption = renderWithRef('DropdownOption', null, (t, e)=>{
    var { children: n } = t;
    return jsx(RenderComp, {
        root: "option",
        forwardedRef: e,
        props: _object_without_properties(t, [
            "children"
        ]),
        children: n
    });
});

export { DropdownOption };
